module.exports = __webpack_public_path__ + "static/media/revert-light.92877056.svg";